import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { FleetGrid } from '../../../../shared/sso-workspace/fleet-grid'
import { FleetPage, Notice } from '../../../../shared/sso-workspace/fleet-page'
import { serverMessage } from '../../../../shared/sso-workspace/format'
import { TableAgInfinite } from '../../../../shared/table-builder/table-ag-infinite'
import { ColumnFormat } from '../../../../shared/table-builder/table-columns'
import { IconList } from '../../../../shared/icon/icon'
import { getCoverage } from './alert-routing-api'
import { ErrorReference } from '../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../shared/error/use-error-line'
import { routesHref } from './paths'

// SSO alert coverage (/admin/sso/alert-coverage, in Sign-in & SSO; owner
// 2026-10-30): organizations on an SSO plan whose own SSO alert list is empty
// (spec §20.5). Their SSO alerts fall back to the platform list. Each links to
// that organization's SSO workspace; the page links to the SSO alert routes.
// A failed load shows only its notice: an empty list here would say
// "everyone is covered".
export const SSOCoveragePage = () => {
  const [rows, setRows] = useState(null)
  const [error, failure, setError] = useErrorLine()
  const tableRef = useRef()
  useEffect(() => { getCoverage().then(v => setRows(v || []), err => setError(serverMessage(err, "Coverage couldn't be loaded."), err)) }, [setError])
  const getRows = useMemo(() => async (start, end) => (rows ? { data: rows.slice(start, end), count: rows.length } : { data: [], count: 0 }), [rows])
  return (
    <FleetPage title="SSO alert coverage"
      purpose="SSO organizations with no SSO alert list of their own. Their SSO alerts go to the platform's list."
      actions={<Link className="btn sw-btn" to={routesHref('sso')}>SSO alert routes</Link>}>
      {error && <Notice tone="bad" role="alert">{error}<ErrorReference error={failure} /></Notice>}
      {!error && <FleetGrid title="Organizations" tableRef={tableRef} rows={rows ? rows.length : 0}>
        <TableAgInfinite key={rows ? rows.length : 'x'} ref={tableRef} queryKey="" onGetRows={getRows}
          emptyState={{ Icon: IconList, title: 'Every SSO organization has a list', message: 'Nothing to chase.' }}>
          <ColumnFormat field="organizationName" header="Organization" sortable={false} flex={2} render={r => (r.data ? r.value : '')} />
          <ColumnFormat field="organizationID" header="" sortable={false} fit="content"
            render={r => (r.data ? <Link to={`/admin/organization/list/edit/${r.value}/sso`} aria-label={`Open the organization ${r.data.organizationName}`}>Open the organization</Link> : '')} />
        </TableAgInfinite>
      </FleetGrid>}
    </FleetPage>
  )
}
